var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBinoculars(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 31.6667C0 32.5411 0.708863 33.25 1.58331 33.25H15.8333C16.7078 33.25 17.4166 32.5411 17.4166 31.6667V28.5H0V31.6667Z",
    fill: "#D7181D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8833 17.4166H23.1166L22.1666 26.9166H36.4166L34.8333 11.0833H23.7499L23.4333 14.2499H14.5666L14.2499 11.0833H3.16663L1.58325 26.9166H15.8333L14.8833 17.4166Z",
    fill: "#D7181D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75006 9.5H12.6667V7.91669H14.2501V4.75H3.16675V7.91669H4.75006V9.5Z",
    fill: "#D7181D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5833 28.5V31.6667C20.5833 32.5411 21.2921 33.25 22.1666 33.25H36.4166C37.291 33.25 37.9999 32.5411 37.9999 31.6667V28.5H20.5833Z",
    fill: "#D7181D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3333 9.5H33.25V7.91669H34.8333V4.75H23.75V7.91669H25.3333V9.5Z",
    fill: "#D7181D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBinoculars);
export default __webpack_public_path__ + "static/media/icon-binoculars.bc765f3fe834038284a4218c7da2a424.svg";
export { ForwardRef as ReactComponent };